import apiService from '../api/apiService';

const hotelId = localStorage.getItem('hotel');

let roomTypes = [];

const fetchAllRoomTypes = async hotelId => {
  try {
    const response = await apiService.get(`/room-types/?hotel=${hotelId}`);
    roomTypes = response;
    return roomTypes;
  } catch (error) {
    console.log('Error fetching room types:', error);
    return [];
  }
};

export const initializeRoomTypes = async () => {
  await fetchAllRoomTypes(hotelId);
};

export const getRoomTypeNameById = id => {
  const type = roomTypes.find(rt => rt.id === id);
  return type?.name || 'Unknown';
};
